import { FunctionComponent, ReactElement } from 'react';

import { Box, FormControl } from '@mui/material';

import { BaseButton } from '../../../../../shared/components/base-button/base-button';
import { useNavigateToRoute } from '../../../../../shared/hooks/use-navigate-to-route/use-navigate-to-route.hook';
import useChangePrompt from '../../../../shared/hooks/use-change-prompt/use-change-prompt.hook';

export const ActionButtons: FunctionComponent = (): ReactElement => {
  const navigateToGamesOverview = useNavigateToRoute(
    '../../game-center-management'
  );

  const cancelAction = useChangePrompt(
    true,
    navigateToGamesOverview,
    <span>Warning</span>,
    <span>Filled information will be lost. Leave anyway?</span>
  );

  return (
    <FormControl
      classes={{
        root: 'button-container',
      }}
    >
      <Box className="button-container-wrapper">
        <BaseButton className="btn btn-white" onClick={cancelAction}>
          Cancel
        </BaseButton>

        <BaseButton type="submit" className="btn btn-primary">
          Save
        </BaseButton>
      </Box>
    </FormControl>
  );
};
